import { capabilities } from 'navigation-components/capabilities';
import { CALLING_COMPONENT } from 'navigation-components/config';
import { useCapability, useComponentState, useToggleComponent } from 'navigation-components/platform/hooks';
import { useCallback, useEffect, useState } from 'react';
export const useCloseCallRemoteOnOutsideClick = callIconRef => {
  const [shouldShowActiveCallState, setShouldShowActiveCallState] = useState(false);
  const [shouldShowEndCallState, setShouldShowEndCallState] = useState(false);
  const {
    isOpen: isCallRemoteOpen
  } = useComponentState(CALLING_COMPONENT);
  const {
    toggle: toggleCallingComponent
  } = useToggleComponent(CALLING_COMPONENT);
  const handleStatusChange = useCallback(({
    shouldShowActiveCallState: _shouldShowActiveCallState,
    shouldShowEndCallState: _shouldShowEndCallState
  }) => {
    if (_shouldShowActiveCallState !== undefined) setShouldShowActiveCallState(_shouldShowActiveCallState);
    if (_shouldShowEndCallState !== undefined) setShouldShowEndCallState(_shouldShowEndCallState);
  }, []);
  const {
    subscribe: subscribeToCallIconStatus
  } = useCapability(capabilities.UPDATE_CALL_ICON_STATUS_CAP.getName());
  useEffect(() => {
    return subscribeToCallIconStatus(handleStatusChange);
  }, [handleStatusChange, subscribeToCallIconStatus]);
  const handleOnClickOutsideCallRemote = useCallback(event => {
    const isClickOutsideCallIcon = callIconRef.current && callIconRef.current.contains && !callIconRef.current.contains(event.target);
    if (isClickOutsideCallIcon && isCallRemoteOpen && !shouldShowActiveCallState && !shouldShowEndCallState) {
      toggleCallingComponent(false);
    }
  }, [callIconRef, isCallRemoteOpen, shouldShowActiveCallState, shouldShowEndCallState, toggleCallingComponent]);
  useEffect(() => {
    if (isCallRemoteOpen) {
      window.addEventListener('click', handleOnClickOutsideCallRemote);
    } else {
      window.removeEventListener('click', handleOnClickOutsideCallRemote);
    }
    return () => {
      window.removeEventListener('click', handleOnClickOutsideCallRemote);
    };
  }, [handleOnClickOutsideCallRemote, isCallRemoteOpen]);
};